module.exports = __webpack_public_path__ + "media/images/sp/page_common/icon/icon_shop_reserve-b63191ae89dcbf79e4174e7f47c1a0be.svg";